import request from '@/utils/request'

/**
 * 批量导入任务列表查询
 * @param {*} data
 * @returns
 */
export const apiGetBatchImportTaskList = data => {
	return request({
		method: 'post',
		url: '/monitor/device/import/list',
		data,
		needJointIsolation: true,
	})
}

/**
 * 批量导入任务创建
 * @param {*} data
 * @returns
 */
export const apiCreateBatchImportTask = data => {
	return request({
		method: 'post',
		url: '/monitor/device/import/add',
		data,
		needJointIsolation: true,
	})
}

/**
 * 取消批量导入任务执行
 * @param {*} data
 * @returns
 */
export const apiCancelBatchImportTask = data => {
	return request({
		method: 'post',
		url: '/monitor/device/import/cancel',
		data,
	})
}

/**
 * 批量导入任务详情查询
 * @param {*} params
 * @returns
 */
export const apiGetBatchImportTaskDetails = params => {
	return request({
		method: 'get',
		url: '/monitor/device/import/detail',
		params,
	})
}

/**
 * 查询设备批量导入子任务列表
 * @param {*} data
 * @returns
 */
export const apiGetBatchImportSubTaskList = data => {
	return request({
		method: 'post',
		url: '/monitor/device/import/detail/list',
		data,
	})
}

/**
 * 批量导入失败任务下载
 * @param {*} data
 * @returns
 */
export const apiDownloadFialSubTask = params => {
	return request({
		method: 'get',
		url: '/monitor/device/import/download',
		params,
		responseType: 'blob',
	})
}
